export default "__VITE_ASSET__22bf8557__"